<script setup lang="ts">
import {pluralize} from "@/core/filters/Pluralize";
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{
    count: number;
}>();
</script>

<template>
  <router-link
    :to="{
      name: 'patient-administration.application.pending-customers',
    }"
  >
    <div class="bg-white p-4 border-[2px] border-orange rounded-lg w-full">
      <div class="flex justify-between gap-4 h-full ">
        <div class="space-y-1">
          <p class="font-bold">
            {{ count }} {{ pluralize("patient", count) }} en attente
          </p>
          <p v-if="count">
            Débloquez leur accès en 2 clics !
          </p>
        </div>
        <Icon name="mdi-chevron-right" :size="30" class="self-center" />
      </div>
    </div>
  </router-link>
</template>

<style scoped>

</style>
